
import React, { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useUserRoleAssignments } from "@/hooks/useUserRoleAssignments";
import { ProfileRole } from "@/types/profileTypes";
import { useIsMobile } from "@/hooks/use-mobile";
import Navbar from "@/components/common/Navbar";
import VendorPressSidebar from "./VendorPressSidebar";

const VendorDashboardLayout: React.FC = () => {
  const { profile, isLoading } = useAuth();
  const { allowedDashboardPaths, roleAssignments, isLoading: roleLoading } = useUserRoleAssignments();
  const isMobile = useIsMobile();
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  console.log('🔍 VendorDashboardLayout - Profile:', profile);
  console.log('🔍 VendorDashboardLayout - Role assignments:', roleAssignments);
  console.log('🔍 VendorDashboardLayout - Allowed dashboard paths:', allowedDashboardPaths);
  console.log('🔍 VendorDashboardLayout - Loading states:', { isLoading, roleLoading });
  console.log('🔍 VendorDashboardLayout - Current window location:', window.location.href);

  // Show loading state while checking authentication
  if (isLoading || roleLoading) {
    console.log('⏳ VendorDashboardLayout - Showing loading state');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user has access to vendor press features
  const hasVendorPressRole = roleAssignments.some(assignment => 
    assignment.role?.slug === 'vendor_press' || assignment.role?.slug === 'press'
  );
  
  const hasVendorAccess = 
    profile?.role === ('vendor_press' as ProfileRole) || 
    profile?.role === ('press' as ProfileRole) ||
    hasVendorPressRole ||
    allowedDashboardPaths.includes('/vendor-press-dashboard') || 
    allowedDashboardPaths.includes('/vendor-dashboard') ||
    profile?.role === ('admin' as ProfileRole);

  console.log('🔐 VendorDashboardLayout - Access check:', {
    hasVendorPressRole,
    hasVendorAccess,
    profileRole: profile?.role
  });

  // Redirect if no access
  if (!profile || !hasVendorAccess) {
    console.log('❌ VendorDashboardLayout - Redirecting to login - no access');
    return <Navigate to="/auth/login" replace />;
  }

  console.log('✅ VendorDashboardLayout - Rendering dashboard');

  return (
    <div className="flex h-screen bg-gray-50 w-full">
      {/* Mobile overlay */}
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      <VendorPressSidebar isOpen={sidebarOpen} />
      
      <div className="flex flex-col flex-1 overflow-hidden min-w-0">
        <Navbar toggleSidebar={toggleSidebar} isAdmin={false} />
        
        <main className="flex-1 overflow-y-auto bg-gray-50 p-3 sm:p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default VendorDashboardLayout;
